import { SidebarItem } from '@backstage/core-components';
import AppsIcon from '@material-ui/icons/Apps';
import { applicationTypes } from './config';
import { buildTypeListPath } from './paths';

/**
 * Deliberately does NOT rely on PageBlueprint's title/icon-driven nav
 * discovery (NavItemBlueprint was removed as of frontend-plugin-api 0.17 —
 * see plugin.tsx for why our pages skip title/icon entirely). Instead this
 * renders plain SidebarItems directly, the same way SidebarLogo,
 * SidebarSearchModal, and NotificationsSidebarItem are hand-placed in
 * modules/nav/Sidebar.tsx. This keeps the sidebar immune to future changes
 * in how nav items get auto-collected from pages.
 *
 * Insert into modules/nav/Sidebar.tsx as:
 *   <SidebarGroup label="Applications" icon={<AppsIcon />}>
 *     <ApplicationSidebarItems />
 *   </SidebarGroup>
 */
export function ApplicationSidebarItems() {
  return (
    <>
      {applicationTypes.map(app => (
        <SidebarItem
          key={app.key}
          icon={AppsIcon}
          to={buildTypeListPath(app.key)}
          text={app.title}
        />
      ))}
    </>
  );
}
